import { LenderFeatureFlagsPortalConfiguration } from '../types';

export const lenderFeatureFlagsDefaultConfig: LenderFeatureFlagsPortalConfiguration = {
  enableEnhancedBusinessProcessFlows: false,
  subsidyReport: false,
};
